import { apiService } from './api';

export interface CustomerPortalResponse {
  success: boolean;
  url: string;
}

export interface CustomerPortalRequest {
  return_url?: string;
}

export class BillingService {
  /**
   * Create a Stripe Customer Portal session for billing management
   */
  static async createCustomerPortalSession(
    returnUrl?: string
  ): Promise<CustomerPortalResponse> {
    try {
      console.log('Creating customer portal session...');
      const response = await apiService.post('/api/v1/billing/create-portal-session', {
        return_url: returnUrl
      }) as CustomerPortalResponse;
      
      console.log('Portal session response:', response);
      return response;
    } catch (error) {
      console.error('Failed to create customer portal session:', error);
      throw new Error('Failed to access billing portal. Please try again.');
    }
  }

  /**
   * Redirect user to Stripe Customer Portal
   */
  static async redirectToCustomerPortal(returnUrl?: string): Promise<void> {
    try {
      const session = await this.createCustomerPortalSession(returnUrl);
      
      if (session.success && session.url) {
        // Redirect to Stripe Customer Portal
        window.location.href = session.url;
      } else {
        throw new Error('Failed to create portal session');
      }
    } catch (error) {
      console.error('Error redirecting to customer portal:', error);
      throw error;
    }
  }

  /**
   * Open Customer Portal in new tab
   */
  static async openCustomerPortalInNewTab(returnUrl?: string): Promise<void> {
    try {
      const session = await this.createCustomerPortalSession(returnUrl);
      
      if (session.success && session.url) {
        // Open Stripe Customer Portal in new tab
        window.open(session.url, '_blank');
      } else {
        throw new Error('Failed to create portal session');
      }
    } catch (error) {
      console.error('Error opening customer portal:', error);
      throw error;
    }
  }
}

export default BillingService;
